'use client';

import { c as _c } from "react/compiler-runtime";
import { useIdleReady } from '@/shared/hooks/use-idle-ready';
import { SystemNotificationBanners } from './system-notification-banners';

/**
 * Global mount point for system notification banners. Rendered once in the
 * root layout so notifications appear on EVERY screen — regardless of which
 * page layout (or none) a route uses. The underlying query only runs for
 * authenticated users, so public/pre-auth pages are a no-op.
 *
 * The banners are held back until the browser is idle. There is nothing to
 * show at t=0 anyway, the notifications query has not resolved, so mounting
 * them in the same commit as the page only competes with the first paint.
 */
export function SystemNotificationHost() {
  const $ = _c(2);
  const isIdleReady = useIdleReady();
  let t0;
  if ($[0] !== isIdleReady) {
    t0 = isIdleReady ? <SystemNotificationBanners /> : null;
    $[0] = isIdleReady;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}